import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { styles } from '../../styles';

export const PrimaryButton: React.FC<Props> = (props) => {
    const onClick = (e) => {
        e.preventDefault();
        if (props.isDisabled) return;
        props.onClick?.(e);
    };
    return <Button onClick={onClick} className={classNames(props.className, { disabled: props.isDisabled })}>
        {props.children}
    </Button>;
};

const Button = styled.a`
  text-decoration: none;
  background-color: #178BFF;
  color: #FFFFFF;
  padding: 10px 45px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: ${styles.fonts.weight.regular};

  &:hover {
    background-color: #0050BC;
  }
  
  &.disabled {
    background-color: #cccccc;
  }
`;

interface Props {
    onClick?: (e: MouseEvent) => void;
    isDisabled?: boolean;
    className?: string;
}
